const Invoice = () => {
  return <>Invoice Page</>;
};

export default Invoice;
